export const textData = {
  "secondTitle1": "MAIN-01",
  "secondTitle2": "MAIN-02",
  "secondTitle3": "MAIN-03",
  "secondTitle4": "MAIN-04",
  "title1": "Развиваем отрасли",
  "title2": "Наши услуги",
  "title3": "Команда",
  "title4": "Соцсети",
  "title5": "Контакты",
}